if(window.innerWidth < 960){
    let menuItems = document.querySelectorAll('.menu .nav-main-item')
    menuItems.forEach(function(item) {
        item.addEventListener('click',function(){
            let activeItem = document.querySelector('.nav-main-item.active')
            console.log(activeItem)
            this.classList.toggle('active')
            if(activeItem){
                activeItem.classList.remove('active')
            }
        })
    })
}

var demarches = document.createElement('a');  
var lien = document.createTextNode("Mes démarches"); 
var menu = document.getElementById('nav-menu__list');

demarches.appendChild(lien);  
demarches.title = "Consulter la page Mes démarches (même onglet)";  
demarches.href = "https://www.dourdan.fr/transitions/mes-demarches/";
demarches.classList.add("nav-menu__item");

menu.appendChild(demarches);  